import { useLang } from "../LanguageContext";
import { Reveal } from "./Reveal";
import { Stars } from "./Stars";

export const Reviews = () => {
  const { t } = useLang();
  return (
    <section id="reviews" className="bg-brown py-24 md:py-36" data-testid="reviews-section">
      <div className="max-w-[1400px] mx-auto px-6 md:px-12">
        <div className="mb-16 md:mb-20 max-w-2xl">
          <Reveal>
            <p className="text-gold text-xs uppercase tracking-[0.35em] mb-6">{t.reviews.chapter}</p>
          </Reveal>
          <Reveal delay={0.1}>
            <h2 className="font-serif text-ivory text-4xl md:text-5xl lg:text-6xl leading-[1.05] tracking-tight">
              {t.reviews.title}
            </h2>
          </Reveal>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 md:gap-8">
          {t.reviews.items.map((r, i) => (
            <Reveal key={i} delay={i * 0.12}>
              <figure className="relative p-8 md:p-10 h-full flex flex-col rounded-xl border border-ivory/10 bg-white/[0.03]" data-testid={`review-${i}`}>
                <span aria-hidden="true" className="font-serif text-gold/30 text-7xl leading-none absolute top-4 right-6 select-none">”</span>
                <Stars size={16} />
                <blockquote className="mt-6 font-serif italic text-ivory/95 text-xl md:text-2xl leading-snug flex-1">
                  “{r.text}”
                </blockquote>
                <figcaption className="mt-10 pt-6 border-t border-ivory/10">
                  <p className="text-ivory text-base font-semibold tracking-wide">{r.author}</p>
                  <p className="text-ivory/50 text-xs mt-1 tracking-wide">{r.meta}</p>
                </figcaption>
              </figure>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
};
